import { Component, inject, Injector, runInInjectionContext } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Timestamp } from '@angular/fire/firestore';
import { FormBuilder, FormGroup } from '@angular/forms';

import {
  PlatformTextProperties,
  PlatformTextPropertiesName,
} from '../../../../../../shared/db-models/media';

@Component({
  selector: 'app-platform-text-properties-form',
  template: `
    <h1>text properties</h1>
    toggle to change the value; when unchecked = value will be the default of the clients<br />

    <form [formGroup]="form" (ngSubmit)="submit()">
      <div *ngFor="let property of properties">
        <label> <input type="checkbox" [formControlName]="property" /> {{ property }} </label>
        <div *ngIf="form.get(property)?.value">
          <input type="text" [formControlName]="property + '-value'" />
        </div>
      </div>
      <button type="submit">Save</button>
    </form>
  `,
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
})
export class PlatformTextPropertiesFormComponent {
  form: FormGroup;
  properties = Object.values(PlatformTextPropertiesName);
  private injector: Injector;
  private fb: FormBuilder;
  private db: AngularFirestore;

  constructor() {
    this.fb = inject(FormBuilder);
    this.db = inject(AngularFirestore);
    this.injector = inject(Injector);
    this.form = this.fb.group({});

    for (const property of this.properties) {
      this.form.addControl(property, this.fb.control(false));
      this.form.addControl(`${property}-value`, this.fb.control(''));
    }
    // Use compat API within injection context to avoid injection errors
    runInInjectionContext(this.injector, () => {
      this.db
        .doc<PlatformTextProperties>('media/textProperties')
        .valueChanges()
        .subscribe((data) => {
          if (data) {
            for (const property of Object.keys(data)) {
              this.form.controls[property].setValue(data[property].value);
              this.form.controls[`${property}-value`].setValue(data[property].value);
            }
          }
        });
    });
  }
  submit() {
    const data = this.form.value;
    const platformTextProperties = {} as PlatformTextProperties;
    for (const property of this.properties) {
      if (data[property]) {
        platformTextProperties[property] = {
          key: property,
          value: data[`${property}-value`],
          uploadedAt: Timestamp.now(),
        };
      }
    }
    // Use compat API within injection context to avoid injection errors
    runInInjectionContext(this.injector, () => {
      this.db.doc('media/textProperties').set({ ...platformTextProperties });
    });
  }
}
